import { Question } from '../types/assessment';

export const substanceUseDisorderQuestions: Question[] = [
  {
    id: 'sud_use_past_year',
    text: 'Have you used any substances (not prescribed or used differently than prescribed) in the past 12 months?',
    type: 'boolean',
    category: 'substance-use-disorder',
    subcategory: 'screening',
    required: true,
    options: [
      { value: true, label: 'Yes', score: 1 },
      { value: false, label: 'No', score: 0 }
    ]
  },
  {
    id: 'sud_work_challenges',
    text: 'Have you experienced any challenges at work, school, or in daily responsibilities related to substance use?',
    type: 'boolean',
    category: 'substance-use-disorder',
    subcategory: 'screening',
    required: true,
    options: [
      { value: true, label: 'Yes', score: 1 },
      { value: false, label: 'No', score: 0 }
    ]
  },
  {
    id: 'sud_relationship_impact',
    text: 'Have your relationships with family, friends, or others been affected by your substance use?',
    type: 'boolean',
    category: 'substance-use-disorder',
    subcategory: 'screening',
    required: true,
    options: [
      { value: true, label: 'Yes', score: 1 },
      { value: false, label: 'No', score: 0 }
    ]
  },
  {
    id: 'sud_health_changes',
    text: 'Have you noticed any changes in your health or wellbeing that you feel might be related to substance use?',
    type: 'boolean',
    category: 'substance-use-disorder',
    subcategory: 'screening',
    required: true,
    options: [
      { value: true, label: 'Yes', score: 1 },
      { value: false, label: 'No', score: 0 }
    ]
  },
  {
    id: 'sud_reduction_consideration',
    text: 'Have you ever felt that reducing or pausing your substance use might support your goals or wellbeing?',
    type: 'boolean',
    category: 'substance-use-disorder',
    subcategory: 'screening',
    required: true,
    options: [
      { value: true, label: 'Yes', score: 1 },
      { value: false, label: 'No', score: 0 }
    ]
  },
  {
    id: 'sud_continued_despite_difficulties',
    text: 'Have you ever continued using a substance even after noticing it was causing difficulties in your life?',
    type: 'boolean',
    category: 'substance-use-disorder',
    subcategory: 'screening',
    required: true,
    options: [
      { value: true, label: 'Yes', score: 1 },
      { value: false, label: 'No', score: 0 }
    ]
  },
  {
    id: 'sud_more_than_intended',
    text: 'Have you ever taken more of a substance than you intended or for longer than you planned?',
    type: 'boolean',
    category: 'substance-use-disorder',
    subcategory: 'screening',
    required: true,
    options: [
      { value: true, label: 'Yes', score: 1 },
      { value: false, label: 'No', score: 0 }
    ]
  },
  {
    id: 'sud_difficulty_cutting_back',
    text: 'Have you tried to cut back or stop using a substance and found it challenging?',
    type: 'boolean',
    category: 'substance-use-disorder',
    subcategory: 'screening',
    required: true,
    options: [
      { value: true, label: 'Yes', score: 1 },
      { value: false, label: 'No', score: 0 }
    ]
  },
  {
    id: 'sud_risky_situations',
    text: 'Have you ever used substances in situations where it might increase risk to your safety or wellbeing?',
    type: 'boolean',
    category: 'substance-use-disorder',
    subcategory: 'screening',
    required: true,
    options: [
      { value: true, label: 'Yes', score: 1 },
      { value: false, label: 'No', score: 0 }
    ]
  },
  {
    id: 'sud_harder_to_manage',
    text: 'Have you ever felt that your substance use was becoming harder to manage than you expected?',
    type: 'boolean',
    category: 'substance-use-disorder',
    subcategory: 'screening',
    required: true,
    options: [
      { value: true, label: 'Yes', score: 1 },
      { value: false, label: 'No', score: 0 }
    ]
  },
  {
    id: 'sud_others_concern',
    text: 'Has anyone you trust ever expressed concern about your substance use in a supportive way?',
    type: 'boolean',
    category: 'substance-use-disorder',
    subcategory: 'screening',
    required: true,
    options: [
      { value: true, label: 'Yes', score: 1 },
      { value: false, label: 'No', score: 0 }
    ]
  },
  {
    id: 'sud_resources_consideration',
    text: 'Have you accessed or considered any resources or supports to explore your substance use or its impact?',
    type: 'boolean',
    category: 'substance-use-disorder',
    subcategory: 'screening',
    required: true,
    options: [
      { value: true, label: 'Yes', score: 1 },
      { value: false, label: 'No', score: 0 }
    ]
  }
]; 